import React from 'react';
import ProfileTab from '@components/profile/profileTabWrap/profileTab';
import { ProfileTabType } from '@domain/constant/ProfileTabType';
import classnames from 'classnames/bind';
import styles from './profileTabWrap.module.scss';

const cx = classnames.bind(styles);

interface ProfileTabWrapProps {
  children: React.ReactNode;
  profileTabType: ProfileTabType;
}

const ProfileTabWrap: React.FC<ProfileTabWrapProps> = ({ children, profileTabType }: ProfileTabWrapProps) => {
  return (
    <div className={cx('profileTabArea')}>
      <div className={cx('profileTabWrap')}>
        {/* 탭 영역 */}
        <ProfileTab profileTabType={profileTabType} />
        {children}
      </div>
    </div>
  );
};

export default ProfileTabWrap;
